import template from './pendingspending.html';
import controller from './pendingspending.controller';

let pendingSpendingComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default pendingSpendingComponent;
